<template>
  <div>
    <modal
      name="errorModal"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 225px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Error</v-toolbar-title>
        </v-toolbar>
        <v-card-subtitle>
          Something went wrong. Please try again. If the error persists, please
          contact support.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('errorModal')"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <v-card ref="form" class="removeTopAndBottomPadding" style="z-index: 999">
      <v-card-title class="removeTopAndBottomPadding">
        <v-row>
          <v-col>
            <h2 class="addressTitle">
              <v-icon color="green" size="36">mdi-lead-pencil</v-icon>&nbsp;Edit
              <!-- <sup>*</sup> -->
            </h2>
          </v-col>
          <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
          <v-col v-if="$vuetify.breakpoint.mdAndUp">
            <v-checkbox
              color="green"
              ref="primaryAgencyInd"
              v-model="primaryAgencyIndLocal"
              :readonly="primaryAgencyInd"
              label="Primary Agency"
              style="padding-top: 20px; padding-bottom: 0px; margin-bottom: 0px"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text v-if="$vuetify.breakpoint.mdAndUp">
        <v-row class="removeTopAndBottomPadding"> </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="agencyName"
              data-test="agency-name"
              v-model="agencyNameLocal"
              :rules="[() => !!agencyNameLocal || 'Agency Name is required']"
              :error-messages="errorMessages"
              label="Agency Name"
              outlined
              required
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="address"
              v-model="addressLocal"
              :rules="[() => !!addressLocal || 'Address line one is required']"
              label="Address"
              outlined
              required
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              ref="address2"
              v-model="address2Local"
              :rules="[]"
              label="Address Line 2"
              outlined
              required
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="city"
              v-model="cityLocal"
              :rules="[() => !!cityLocal || 'City is required', addressCheck]"
              label="City"
              outlined
              dense
              required
            ></v-text-field>
          </v-col>
          <v-col class="removeTopAndBottomPadding">
            <v-autocomplete
              ref="state"
              v-model="stateLocal"
              :rules="[() => !!stateLocal || 'State/Province is required']"
              :items="statesOrProvinces"
              label="State"
              placeholder="Select..."
              required
              outlined
              dense
              v-if="countryLocal == 'United States of America'"
            ></v-autocomplete>
            <v-text-field
              v-if="countryLocal != 'United States of America'"
              ref="state"
              v-model="stateLocal"
              :rules="[() => !!stateLocal || 'State/Province is required']"
              label="State/Province"
              outlined
              dense
              required
            ></v-text-field>
          </v-col>
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="zip"
              v-model="zipLocal"
              :rules="[() => !!zipLocal || 'ZIP/Postal Code is required']"
              label="ZIP / Postal Code"
              required
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-autocomplete
              ref="country"
              v-model="countryLocal"
              :rules="[() => !!countryLocal || 'Country is required']"
              :items="countries"
              label="Country"
              placeholder="Select..."
              required
              outlined
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="4" class="removeTopAndBottomPadding">
            <v-text-field
              ref="phone"
              v-model="phoneLocal"
              :rules="[
                () =>
                  !phoneLocal ||
                  /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(
                    phoneLocal
                  ) ||
                  'Please enter a valid phone number with area code.',
              ]"
              label="Phone Number"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="2" class="removeTopAndBottomPadding">
            <v-text-field
              ref="phoneExt"
              v-model="phoneExtLocal"
              label="Ext"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="email"
              v-model="emailLocal"
              :rules="[
                () => !!emailLocal || 'Primary e-mail address is required.',
              ]"
              label="Primary E-Mail Address"
              outlined
              required
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text v-if="$vuetify.breakpoint.smAndDown">
        <v-row>
          <v-col>
            <v-checkbox
              color="green"
              ref="primaryAgencyInd"
              v-model="primaryAgencyIndLocal"
              :readonly="primaryAgencyInd"
              label="Primary Agency"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="agencyName"
              data-test="agency-name"
              v-model="agencyNameLocal"
              :rules="[() => !!agencyNameLocal || 'Agency Name is required']"
              :error-messages="errorMessages"
              label="Agency Name"
              outlined
              required
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="address"
              v-model="addressLocal"
              :rules="[() => !!addressLocal || 'Address line one is required']"
              label="Address"
              outlined
              required
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              ref="address2"
              v-model="address2Local"
              :rules="[]"
              label="Address Line 2"
              outlined
              required
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="city"
              v-model="cityLocal"
              :rules="[() => !!cityLocal || 'City is required', addressCheck]"
              label="City"
              outlined
              dense
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-autocomplete
              ref="state"
              v-model="stateLocal"
              :rules="[() => !!stateLocal || 'State/Province is required']"
              :items="statesOrProvinces"
              label="State"
              placeholder="Select..."
              required
              outlined
              dense
              v-if="countryLocal == 'United States of America'"
            ></v-autocomplete>
            <v-text-field
              v-if="countryLocal != 'United States of America'"
              ref="state"
              v-model="stateLocal"
              :rules="[() => !!stateLocal || 'State/Province is required']"
              label="State/Province"
              outlined
              dense
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="zip"
              v-model="zipLocal"
              :rules="[() => !!zipLocal || 'ZIP/Postal Code is required']"
              label="ZIP / Postal Code"
              required
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-autocomplete
              ref="country"
              v-model="countryLocal"
              :rules="[() => !!countryLocal || 'Country is required']"
              :items="countries"
              label="Country"
              placeholder="Select..."
              required
              outlined
              dense
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="phone"
              v-model="phoneLocal"
              :rules="[
                () =>
                  !phoneLocal ||
                  /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(
                    phoneLocal
                  ) ||
                  'Please enter a valid phone number with area code.',
              ]"
              label="Phone Number"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="phoneExt"
              v-model="phoneExtLocal"
              label="Ext"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="email"
              v-model="emailLocal"
              :rules="[
                () => !!emailLocal || 'Primary e-mail address is required.',
              ]"
              label="Primary E-Mail Address"
              outlined
              required
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- <span style="font-size:small;margin-left:20px;font-style:italic">
      <sup>*</sup>Agency name and address change requests are subject to home
      office approval.
      </span>-->
      <v-divider class="removeTopAndBottomPadding"></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="menuBtn"
          color="#00558c"
          dark
          @click.native="cancelAddressChange"
          >Cancel</v-btn
        >

        <!-- <v-slide-x-reverse-transition>
            <v-tooltip
              v-if="formHasErrors"
              left
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  class="menuBtn"
                  @click="resetForm"
                  v-on="on"
                  
                >
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>Refresh form</span>
            </v-tooltip>
        </v-slide-x-reverse-transition>-->
        <v-btn color="green" class="menuBtn" dark @click="submit">Submit</v-btn>
      </v-card-actions>
      <v-progress-circular
        indeterminate
        color="green"
        v-if="waitCircle"
        size="50"
        class="waitCircle"
      ></v-progress-circular>
    </v-card>
    <template></template>
  </div>
</template>
<script>
import EventBus from "../eventBus.js";

import API, { graphqlOperation } from "@aws-amplify/api";
import * as queries from "@/graphql/queries";
import utilityMixins from "@/utility-mixins.js";
import * as mutations from "@/graphql/mutations";
import { HTTP } from "@/http-common.js";

export default {
  mixins: [utilityMixins],
  props: {
    id: String,
    code: String,
    agencyName: String,
    address: String,
    address2: String,
    city: String,
    state: String,
    zip: String,
    country: String,
    phone: String,
    phoneExt: String,
    email: String,
    companyId: String,
    countryCode: String,
    phoneTypeId: String,
    aoId: String,
    aoName: String,
    addressTypeId: String,
    countryId: String,
    primaryAgencyInd: Boolean,
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.isMobileCheck);
  },

  created() {
    this.isMobileCheck();

    window.addEventListener("resize", this.isMobileCheck);

    this.agencyNameLocal = this.agencyName;
    this.addressLocal = this.address;
    this.address2Local = this.address2;
    this.cityLocal = this.city;
    this.stateLocal = this.state;
    this.zipLocal = this.zip;
    this.countryLocal = this.country;
    this.phoneLocal = this.phone;
    this.phoneExtLocal = this.phoneExt == "" ? " " : this.phoneExt;
    this.emailLocal = this.email;
    this.primaryAgencyIndLocal = this.primaryAgencyInd;

    this.getCountries();
  },
  data: () => ({
    waitCircle: false,
    countries: [],
    countriesArray: [],
    provinces: [
      "Alberta",
      "British Columbia",
      "Manitoba",
      "New Brunswick",
      "Newfoundland",
      "Labrador",
      "Nova Scotia",
      "Ontario",
      "Prince Edward Island",
      "Quebec",
      "Saskatchewan",
    ],
    // To Do: get states from DynamoDb
    states: [
      "AL",
      "AK",
      "AZ",
      "AR",
      "AS",
      "CA",
      "CO",
      "CT",
      "DC",
      "DE",
      "FL",
      "FM",
      "GA",
      "GU",
      "HI",
      "ID",
      "IL",
      "IN",
      "IA",
      "KS",
      "KY",
      "LA",
      "ME",
      "MD",
      "MA",
      "MH",
      "MI",
      "MN",
      "MP",
      "MS",
      "MO",
      "MT",
      "NE",
      "NV",
      "NH",
      "NJ",
      "NM",
      "NY",
      "NC",
      "ND",
      "OH",
      "OK",
      "OR",
      "PA",
      "PW",
      "PR",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VI",
      "VT",
      "VA",
      "WA",
      "WV",
      "WI",
      "WY",
    ],
    errorMessages: "",
    agencyNameLocal: null,
    addressLocal: null,
    address2Local: null,
    cityLocal: null,
    stateLocal: null,
    zipLocal: null,
    countryLocal: null,
    phoneLocal: null,
    phoneExtLocal: null,
    emailLocal: null,
    primaryAgencyIndLocal: null,
    formHasErrors: false,
  }),

  computed: {
    statesOrProvinces() {
      let sts = this.states;

      return sts.sort((a, b) => {
        if (a > b) return 1;
        if (b > a) return -1;

        return 0;
      });
    },

    form() {
      return {
        agencyName: this.agencyNameLocal,
        address: this.addressLocal,
        address2: this.address2Local,
        city: this.cityLocal,
        state: this.stateLocal,
        zip: this.zipLocal,
        country: this.countryLocal,
        phone: this.phoneLocal,
        phoneExt: this.phoneExtLocal,
        email: this.emailLocal,
        primaryAgencyInd: this.primaryAgencyIndLocal,
      };
    },
  },

  watch: {
    name() {
      this.errorMessages = "";
    },
    countryLocal() {
      if (this.countryLocal != "United States of America") {
        if (this.states.indexOf(this.stateLocal) >= 0)
          this.stateLocal = undefined;
      }
    },
    statesOrProvinces() {
      if (!this.statesOrProvinces.find((sp) => sp == this.stateLocal)) {
        this.stateLocal = undefined;
      }
    },
  },

  methods: {
    async getCountries() {
      this.countries = [];

      this.waitCircle = true;
      let countries = await API.graphql(
        graphqlOperation(queries.getCountries)
      ).catch(() => {
        this.waitCircle = false;
        return;
      });

      //Filter out non US countries
      let countryList = this.$store.state.countryList;
      for (let country of countries.data.getCountries) {
        if (countryList.find((elem) => elem == country.code)) {
          this.countries.push(country.name);
          this.countriesArray.push(country);
        }
      }

      this.countries.sort((a, b) => {
        if (a > b) return 1;
        if (b > a) return -1;
        return 0;
      });
      this.waitCircle = false;
    },
    cancelAddressChange() {
      EventBus.$emit("addressChangeCancel");
    },
    addressCheck() {
      return true;
    },
    resetForm() {
      this.errorMessages = [];
      this.formHasErrors = false;

      Object.keys(this.form).forEach((f) => {
        this.$refs[f].reset();
      });
    },
    async submit() {
      this.formHasErrors = false;

      let valid = true;

      Object.keys(this.form).forEach((f) => {
        if (
          f == "state" &&
          this.countryLocal == "United States of America" &&
          !this.statesOrProvinces.find((sp) => sp == this.form[f])
        )
          valid = false;

        if (!this.form[f]) this.formHasErrors = true;

        if (!this.$refs[f].validate(true)) valid = false;
      });

      if (valid) {
        if (!this.code) {
          EventBus.$emit("addressChange", this.form);
          return;
        }

        let AOsAgencies = await API.graphql(
          graphqlOperation(queries.getAgenciesByAONum, {
            aoNum: this.aoId,
            company: this.$store.state.currentCompany,
          })
        ).catch((e) => {
          this.addToErrorLogs("agency-address getAgenciesByAONum", e);
        });

        let OtherAgencies = [];

        if (AOsAgencies.data.getAgenciesByAONum.length) {
          OtherAgencies = AOsAgencies.data.getAgenciesByAONum.filter(
            (a) => a.AgencyCode != this.code
          );
        }

        let agencyUpdatesInfo = {
          company: this.$store.state.currentCompany,
          agencyId: this.code ? this.code : "",
          agencyName: this.agencyNameLocal ? this.agencyNameLocal : "",
          agencyNameOrig: this.agencyName ? this.agencyName : "",
          agencyEmailOrig: this.email ? this.email : "",
          agencyEmail: this.emailLocal ? this.emailLocal : "",
          aoNum: this.aoId ? this.aoId : "",
          aoName: this.aoName ? this.aoName : "",
          aoNumOrig: this.aoId ? this.aoId : "", // not changing AO here
          aoNameOrig: this.aoName ? this.aoName : "", // not changing AO here
          agencyAddress1Orig: this.address ? this.address : "",
          agencyAddress1: this.addressLocal ? this.addressLocal : "",
          agencyAddress2Orig: this.address2 ? this.address2 : "",
          agencyAddress2: this.address2Local ? this.address2Local : "",
          agencyCityOrig: this.city ? this.city : "",
          agencyCity: this.cityLocal ? this.cityLocal : "",
          agencyStateProvinceOrig: this.state ? this.state : "",
          agencyStateProvince: this.stateLocal ? this.stateLocal : "",
          agencyPostalCodeOrig: this.zip ? this.zip : "",
          agencyPostalCode: this.zipLocal ? this.zipLocal : "",
          agencyCountryOrig: this.country ? this.country : "",
          agencyCountry: this.countryLocal ? this.countryLocal : "",
          agencyAreaCode:
            this.form.phone.length == 10 ? this.form.phone.substr(0, 3) : "",
          agencyAreaCodeOrig:
            this.phone.length == 10 ? this.phone.substr(0, 3) : "",
          agencyPhoneOrig:
            this.phone.length == 10
              ? this.phone.substr(3)
              : this.phone
              ? this.phone
              : "",

          agencyPhone:
            this.form.phone.length == 10
              ? this.form.phone.substr(3)
              : this.form.phone
              ? this.form.phone
              : "",

          agencyPhoneExtOrig: this.phoneExt ? this.phoneExt : "",
          agencyPhoneExt: this.phoneExtLocal ? this.phoneExtLocal : "",
          updatedBy:
            this.$store.state.currentUser.name +
            " (" +
            this.$store.state.currentUser.agentNum +
            ")",
          primaryAgencyInd: this.primaryAgencyIndLocal
            ? this.primaryAgencyIndLocal
            : false,
          primaryAgencyIndOrig: this.primaryAgencyInd
            ? this.primaryAgencyInd
            : false,
        };

        let addressChanged = true;
        let phoneChanged = true;
        let nameOrEmailChanged = true;
        let primaryAgencyIndChanged = true;

        if (
          this.agencyName == this.agencyNameLocal &&
          this.email == this.emailLocal
        ) {
          nameOrEmailChanged = false;
        }

        if (this.primaryAgencyInd == this.primaryAgencyIndLocal) {
          primaryAgencyIndChanged = false;
        }

        if (
          this.address == this.addressLocal &&
          this.address2 == this.address2Local &&
          this.city == this.cityLocal &&
          this.state == this.stateLocal &&
          this.zip == this.zipLocal &&
          this.country == this.countryLocal
        )
          addressChanged = false;

        let ph = this.phone ? this.phone.trim() : this.phone;
        let phLocal = this.phoneLocal
          ? this.phoneLocal.trim()
          : this.phoneLocal;

        let phExt = this.phoneExt ? this.phoneExt.trim() : this.phoneExt;
        let phExtLocal = this.phoneExtLocal
          ? this.phoneExtLocal.trim()
          : this.phoneExtLocal;

        if (ph == phLocal && phExt == phExtLocal) {
          phoneChanged = false;
        }

        let selectedCountry = this.countriesArray.find(
          (c) => c.name == this.countryLocal
        );

        let AgencyUpdate = {
          CompanyID: this.companyId,
          AOAgentNumPrimary: this.aoId,
          Name: this.form.agencyName,
          Email: this.form.email,
          CreatedBy:
            "AMT: " +
            this.$store.state.currentUser.name +
            " (" +
            this.$store.state.currentUser.agentNum +
            ")",
          AgencyCode: this.code,
          AddressTypeID: this.addressTypeId,
          AddressLine1: this.form.address,
          AddressLine2: this.form.address2,
          City: this.form.city,
          StateProvinceCode: this.form.state,
          PostalCode: this.form.zip,
          GLCountryID: selectedCountry ? selectedCountry.id : this.countryId,
          GLPhoneTypeID: this.phoneTypeId,
          AreaCode:
            this.form.phone.length == 10 ? this.form.phone.substr(0, 3) : "",
          PhoneNum:
            this.form.phone.length == 10
              ? this.form.phone.substr(3)
              : this.form.phone,
          PhoneExtensionNum: this.form.phoneExt,
          PrimaryAgencyInd: this.form.primaryAgencyInd,
        };

        if (nameOrEmailChanged || primaryAgencyIndChanged) {
          this.waitCircle = true;
          await API.graphql(
            graphqlOperation(mutations.updateAgency, {
              input: AgencyUpdate,
            })
          ).catch((e) => {
            this.addToErrorLogs("agency-address.vue submit updateAgency", e);
            this.waitCircle = false;
            this.$modal.show("errorModal");
            return;
          });
          this.waitCircle = false;
        }

        if (addressChanged) {
          this.waitCircle = true;
          await API.graphql(
            graphqlOperation(mutations.updateAgencyAddress, {
              input: AgencyUpdate,
            })
          ).catch((e) => {
            this.addToErrorLogs(
              "agency-address.vue submit updateAgencyAddress",
              e
            );
            this.waitCircle = false;
            this.$modal.show("errorModal");
            return;
          });
          this.waitCircle = false;
        }

        if (phoneChanged) {
          this.waitCircle = true;
          await API.graphql(
            graphqlOperation(mutations.updateAgencyPhone, {
              input: AgencyUpdate,
            })
          ).catch((e) => {
            this.addToErrorLogs(
              "agency-address.vue submit updateAgencyPhone",
              e
            );
            this.waitCircle = false;
            this.$modal.show("errorModal");
            return;
          });
          this.waitCircle = false;
        }

        if (
          phoneChanged ||
          nameOrEmailChanged ||
          primaryAgencyIndChanged ||
          addressChanged
        ) {
          try {
            HTTP.post("history", agencyUpdatesInfo, {
              headers: {
                "Content-Type": "application/json",
              },
            })
              .then((response) => {
                if (response.status != 200) {
                  this.addToErrorLogs(
                    "agency-address.vue submit post history",
                    JSON.stringify(response)
                  );
                }
              })
              .catch((e) => {
                this.addToErrorLogs(
                  "agency-address.vue submit post history",
                  e
                );
              });
          } catch (e) {
            this.addToErrorLogs("agency-address.vue submit", e);
          }

          if (primaryAgencyIndChanged) {
            let AOsAgencies = await API.graphql(
              graphqlOperation(queries.getAgenciesByAONum, {
                aoNum: this.aoId,
                company: this.$store.state.currentCompany,
              })
            ).catch((e) => {
              this.addToErrorLogs("agency-address getAgenciesByAONum", e);
            });

            let OtherChangedAgencies = [];

            if (AOsAgencies.data.getAgenciesByAONum.length) {
              OtherChangedAgencies = AOsAgencies.data.getAgenciesByAONum.filter(
                (a) => a.AgencyCode != this.code
              );
            }

            for (let original of OtherAgencies) {
              for (let updated of OtherChangedAgencies) {
                if (
                  original.AgencyCode == updated.AgencyCode &&
                  original.PrimaryAgencyInd != updated.PrimaryAgencyInd
                ) {
                  let agencyUpdatesInfoPAI = {
                    company: this.$store.state.currentCompany,
                    agencyId: updated.AgencyCode,
                    agencyName: updated.AgencyName,
                    agencyNameOrig: original.AgencyName,
                    agencyEmailOrig: original.Email,
                    agencyEmail: updated.Email,
                    aoNum: updated.AOAgentNumPrimary,
                    aoName: this.aoName,
                    aoNumOrig: original.AOAgentNumPrimary,
                    aoNameOrig: this.aoName,
                    agencyAddress1Orig: original.AddressLine1,
                    agencyAddress1: updated.AddressLine1,
                    agencyAddress2Orig: original.AddressLine2,
                    agencyAddress2: updated.AddressLine2,
                    agencyCityOrig: original.City,
                    agencyCity: updated.City,
                    agencyStateProvinceOrig: original.StateProvinceCode,
                    agencyStateProvince: updated.StateProvinceCode,
                    agencyPostalCodeOrig: original.PostalCode,
                    agencyPostalCode: updated.PostalCode,
                    agencyCountryOrig: original.CountryName,
                    agencyCountry: updated.CountryName,
                    agencyAreaCode: updated.AreaCode,
                    agencyAreaCodeOrig: original.AreaCode,
                    agencyPhoneOrig: original.PhoneNum,
                    agencyPhone: updated.PhoneNum,
                    agencyPhoneExtOrig: original.PhoneExtensionNum,
                    agencyPhoneExt: updated.PhoneExtensionNum,
                    updatedBy:
                      this.$store.state.currentUser.name +
                      " (" +
                      this.$store.state.currentUser.agentNum +
                      ")",
                    primaryAgencyInd: updated.PrimaryAgencyInd,
                    primaryAgencyIndOrig: original.PrimaryAgencyInd,
                  };

                  try {
                    HTTP.post("history", agencyUpdatesInfoPAI, {
                      headers: {
                        "Content-Type": "application/json",
                      },
                    })
                      .then((response) => {
                        if (response.status != 200) {
                          this.addToErrorLogs(
                            "agency-address.vue submit post history",
                            JSON.stringify(response)
                          );
                        }
                      })
                      .catch((e) => {
                        this.addToErrorLogs(
                          "agency-address.vue submit post history",
                          e
                        );
                      });
                  } catch (e) {
                    this.addToErrorLogs("agency-address.vue submit", e);
                  }
                }
              }
            }
          }
        }
        EventBus.$emit("addressChange", this.form);
      }
    },
  },
};
</script>
<style scoped>
.drop {
  margin-top: 100px;
}
.addressTitle {
  color: green;
  font-size: 2rem;
  font-weight: normal;
  margin-left: 20px;
  padding-top: 20px;
}
.removeTopAndBottomPadding {
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
}
.waitCircle {
  z-index: 20;
  position: absolute;
  top: 50%;
  left: 48%;
}
</style>
